import { withStyles, TableCell } from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
    root: {
      padding: '8px',
      height: 'auto',
      fontWeight: 500,
      fontSize: theme.textFontSize,
    },
    body: {
      color: theme.printTableLabel,
      border: `1px solid ${theme.KPI.KPIButton}`,
    }
  }))(TableCell);

export default StyledTableCell;